export class FlexProduct {
  readonly productType?: number;
  readonly name?: string;

  constructor(productType?: number, name?: string) {
    this.productType = productType;
    this.name = name;
  }
}

export class FlexEnrollment {
  readonly externalId?: string;
  readonly appPid?: number;
  readonly startDate?: string;
  readonly premium?: number;

  constructor(
    externalId?: string,
    appPid?: number,
    startDate?: string,
    premium?: number
  ) {
    this.externalId = externalId;
    this.appPid = appPid;
    this.startDate = startDate;
    this.premium = premium;
  }
}

/**
 * The person the external plan covers. Present only on FlexBenefits standalone
 * members (PPI-1391 QA): when a member holds no Pivot application at all, the
 * applications response comes back with an empty `apps` array and the covered
 * person's identity only exists here, on the external plan itself. It is a
 * different shape from `Member` -- no id, gender or relationship -- so it is its
 * own type rather than a partially-filled Member.
 */
export class FlexMember {
  readonly firstName?: string;
  readonly lastName?: string;
  readonly dob?: string;

  constructor(firstName?: string, lastName?: string, dob?: string) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.dob = dob;
  }
}

export class FlexPackage {
  readonly id?: string;
  readonly name?: string;
  readonly products: FlexProduct[];
  readonly enrollment?: FlexEnrollment;
  readonly member?: FlexMember;

  constructor(
    id?: string,
    name?: string,
    products: FlexProduct[] = [],
    enrollment?: FlexEnrollment,
    member?: FlexMember
  ) {
    this.id = id;
    this.name = name;
    this.products = products;
    this.enrollment = enrollment;
    this.member = member;
  }
}
